import { combineReducers, configureStore, UnknownAction } from '@reduxjs/toolkit'

import { sbpPaymentsReducer } from '@/stores/slices/sbp-payments-slice.ts'
import { userReducer } from '@/stores/slices/user-slice.ts'
import { templatesReducer } from '@/stores/slices/templates-slice.ts'
import { operationRequestsReducer } from '@/stores/slices/operation-requests-slice.ts'
import { acquiringPaymentsReducer } from '@/stores/slices/acquiring-payments-slice.ts'
import { b2bReducer } from '@/stores/slices/b2b-slice.ts'
import { c2bReducer } from '@/stores/slices/c2b-slice.ts'
import { b2cReducer } from '@/stores/slices/b2c-slice/b2c-slice.ts'
import { b2cOneTimePaymentsReducer } from '@/stores/slices/b2c-slice/b2c-one-time-payments-slice.ts'
import { b2cRegistryPaymentsReducer } from '@/stores/slices/b2c-slice/b2c-registry-payments-slice.ts'
import { b2cRegistryReducer } from '@/stores/slices/b2c-registry-slice.ts'

export * from './stores.types.ts'

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
type AppState = ReturnType<typeof appReducer>

export const appReducer = combineReducers({
  sbpPayments: sbpPaymentsReducer,
  templates: templatesReducer,
  operationRequests: operationRequestsReducer,
  acquiringPayments: acquiringPaymentsReducer,
  b2b: b2bReducer,
  c2b: c2bReducer,
  b2c: b2cReducer,
  b2cOneTimePayments: b2cOneTimePaymentsReducer,
  b2cRegistryPayments: b2cRegistryPaymentsReducer,
  b2cRegistry: b2cRegistryReducer,
  user: userReducer,
})

const rootReducer = (state: AppState | undefined, action: UnknownAction): AppState => {
  if (action.type === 'RESET_APP') {
    return appReducer(undefined, action)
  }
  if (action.type === 'RESET_APP_KEEP_LAST_USER_ID') {
    const fresh = appReducer(undefined, action)
    return {
      ...fresh,
      user: {
        ...fresh.user,
        lastUserId: state?.user.lastUserId ?? null,
      },
    }
  }
  return appReducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

export const resetAppAction = () => ({ type: 'RESET_APP' }) as const
export const resetAppKeepLastUserIdAction = () => ({ type: 'RESET_APP_KEEP_LAST_USER_ID' }) as const
